// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_org_fsd_struct.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { StcsFpnaTypeEnum, stcsFpnaTypeEnumFromJSON, stcsFpnaTypeEnumToJSON } from "./stcs_enums.entity";

export const protobufPackage = "stcs_cmw";

/** v2.0.1 */
export interface StcsOrgFsdStruct {
  id: string;
  version: string;
  meta: StcsOrgFsdStructMeta | undefined;
  pnl: StcsOrgFsdStructFstmt | undefined;
  bs: StcsOrgFsdStructFstmt | undefined;
  cf: StcsOrgFsdStructFstmt | undefined;
}

export interface StcsOrgFsdStructMeta {
  ref_id_org: string;
  ref_id_user: string;
  ref_id_org_fsd_flat: string;
  fpna_industry: number;
  display_name: string;
  version_name: string;
  obj_created_iso_utc: string;
  obj_updated_iso_utc: string;
}

export interface StcsOrgFsdStructFstmt {
  fstmt_item_list: StcsOrgFsdStructFstmtItem[];
}

export interface StcsOrgFsdStructFstmtItem {
  fpna_type: StcsFpnaTypeEnum;
  id: string;
  level_id: string;
  total_list: StcsOrgFsdStructFstmtItem[];
  sub_total_list: StcsOrgFsdStructSubTotal[];
  level_1_list: StcsOrgFsdStructLevel1[];
  ctx_line_def: StcsOrgFsdStructCtxLineDef | undefined;
  options: StcsOrgFsdStructOptions | undefined;
}

export interface StcsOrgFsdStructOptions {
  filter_on_zero_sum_period?: boolean | undefined;
  bs_cf_delta?: boolean | undefined;
  is_cml?: boolean | undefined;
  active_fstmt_side?: boolean | undefined;
  invert_sum_value: number;
  skip_path_level_1?: boolean | undefined;
}

export interface StcsOrgFsdStructSubTotal {
  id: string;
  level_id: string;
  level_1_list: StcsOrgFsdStructLevel1[];
  ctx_line_def: StcsOrgFsdStructCtxLineDef | undefined;
  fpna_type: StcsFpnaTypeEnum;
  options: StcsOrgFsdStructOptions | undefined;
  ref_id_prefix?: string | undefined;
  ref_id_mirror?: string | undefined;
}

export interface StcsOrgFsdStructCtxLineDef {
  ctx_line_type: StcsFpnaTypeEnum;
  fstmt_ref_id: string;
  level_id: string;
}

export interface StcsOrgFsdStructLevel1 {
  id: string;
  level_id: string;
  sum_ref?: string | undefined;
  level_2_list: StcsOrgFsdStructLevel2[];
  fpna_type: StcsFpnaTypeEnum;
  options: StcsOrgFsdStructOptions | undefined;
  ref_id_prefix?: string | undefined;
  ref_id_mirror?: string | undefined;
}

export interface StcsOrgFsdStructLevel2 {
  id: string;
  level_id: string;
  sum_ref?: string | undefined;
  options: StcsOrgFsdStructOptions | undefined;
  fpna_type: StcsFpnaTypeEnum;
  ref_id_prefix?: string | undefined;
  ref_id_mirror?: string | undefined;
}

function createBaseStcsOrgFsdStruct(): StcsOrgFsdStruct {
  return { id: "", version: "", meta: undefined, pnl: undefined, bs: undefined, cf: undefined };
}

export const StcsOrgFsdStruct: MessageFns<StcsOrgFsdStruct> = {
  encode(message: StcsOrgFsdStruct, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.version !== "") {
      writer.uint32(18).string(message.version);
    }
    if (message.meta !== undefined) {
      StcsOrgFsdStructMeta.encode(message.meta, writer.uint32(26).fork()).join();
    }
    if (message.pnl !== undefined) {
      StcsOrgFsdStructFstmt.encode(message.pnl, writer.uint32(34).fork()).join();
    }
    if (message.bs !== undefined) {
      StcsOrgFsdStructFstmt.encode(message.bs, writer.uint32(42).fork()).join();
    }
    if (message.cf !== undefined) {
      StcsOrgFsdStructFstmt.encode(message.cf, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgFsdStruct {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgFsdStruct();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.version = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.meta = StcsOrgFsdStructMeta.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.pnl = StcsOrgFsdStructFstmt.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.bs = StcsOrgFsdStructFstmt.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.cf = StcsOrgFsdStructFstmt.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgFsdStruct {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      meta: isSet(object.meta) ? StcsOrgFsdStructMeta.fromJSON(object.meta) : undefined,
      pnl: isSet(object.pnl) ? StcsOrgFsdStructFstmt.fromJSON(object.pnl) : undefined,
      bs: isSet(object.bs) ? StcsOrgFsdStructFstmt.fromJSON(object.bs) : undefined,
      cf: isSet(object.cf) ? StcsOrgFsdStructFstmt.fromJSON(object.cf) : undefined,
    };
  },

  toJSON(message: StcsOrgFsdStruct): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.meta !== undefined) {
      obj.meta = StcsOrgFsdStructMeta.toJSON(message.meta);
    }
    if (message.pnl !== undefined) {
      obj.pnl = StcsOrgFsdStructFstmt.toJSON(message.pnl);
    }
    if (message.bs !== undefined) {
      obj.bs = StcsOrgFsdStructFstmt.toJSON(message.bs);
    }
    if (message.cf !== undefined) {
      obj.cf = StcsOrgFsdStructFstmt.toJSON(message.cf);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgFsdStruct>, I>>(base?: I): StcsOrgFsdStruct {
    return StcsOrgFsdStruct.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgFsdStruct>, I>>(object: I): StcsOrgFsdStruct {
    const message = createBaseStcsOrgFsdStruct();
    message.id = object.id ?? "";
    message.version = object.version ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? StcsOrgFsdStructMeta.fromPartial(object.meta)
      : undefined;
    message.pnl = (object.pnl !== undefined && object.pnl !== null)
      ? StcsOrgFsdStructFstmt.fromPartial(object.pnl)
      : undefined;
    message.bs = (object.bs !== undefined && object.bs !== null)
      ? StcsOrgFsdStructFstmt.fromPartial(object.bs)
      : undefined;
    message.cf = (object.cf !== undefined && object.cf !== null)
      ? StcsOrgFsdStructFstmt.fromPartial(object.cf)
      : undefined;
    return message;
  },
};

function createBaseStcsOrgFsdStructMeta(): StcsOrgFsdStructMeta {
  return {
    ref_id_org: "",
    ref_id_user: "",
    ref_id_org_fsd_flat: "",
    fpna_industry: 0,
    display_name: "",
    version_name: "",
    obj_created_iso_utc: "",
    obj_updated_iso_utc: "",
  };
}

export const StcsOrgFsdStructMeta: MessageFns<StcsOrgFsdStructMeta> = {
  encode(message: StcsOrgFsdStructMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_org !== "") {
      writer.uint32(10).string(message.ref_id_org);
    }
    if (message.ref_id_user !== "") {
      writer.uint32(18).string(message.ref_id_user);
    }
    if (message.ref_id_org_fsd_flat !== "") {
      writer.uint32(66).string(message.ref_id_org_fsd_flat);
    }
    if (message.fpna_industry !== 0) {
      writer.uint32(24).uint32(message.fpna_industry);
    }
    if (message.display_name !== "") {
      writer.uint32(34).string(message.display_name);
    }
    if (message.version_name !== "") {
      writer.uint32(42).string(message.version_name);
    }
    if (message.obj_created_iso_utc !== "") {
      writer.uint32(50).string(message.obj_created_iso_utc);
    }
    if (message.obj_updated_iso_utc !== "") {
      writer.uint32(58).string(message.obj_updated_iso_utc);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgFsdStructMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgFsdStructMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.ref_id_org_fsd_flat = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.fpna_industry = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.display_name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.version_name = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.obj_created_iso_utc = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.obj_updated_iso_utc = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgFsdStructMeta {
    return {
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org_fsd_flat: isSet(object.ref_id_org_fsd_flat) ? globalThis.String(object.ref_id_org_fsd_flat) : "",
      fpna_industry: isSet(object.fpna_industry) ? globalThis.Number(object.fpna_industry) : 0,
      display_name: isSet(object.display_name) ? globalThis.String(object.display_name) : "",
      version_name: isSet(object.version_name) ? globalThis.String(object.version_name) : "",
      obj_created_iso_utc: isSet(object.obj_created_iso_utc) ? globalThis.String(object.obj_created_iso_utc) : "",
      obj_updated_iso_utc: isSet(object.obj_updated_iso_utc) ? globalThis.String(object.obj_updated_iso_utc) : "",
    };
  },

  toJSON(message: StcsOrgFsdStructMeta): unknown {
    const obj: any = {};
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org_fsd_flat !== "") {
      obj.ref_id_org_fsd_flat = message.ref_id_org_fsd_flat;
    }
    if (message.fpna_industry !== 0) {
      obj.fpna_industry = Math.round(message.fpna_industry);
    }
    if (message.display_name !== "") {
      obj.display_name = message.display_name;
    }
    if (message.version_name !== "") {
      obj.version_name = message.version_name;
    }
    if (message.obj_created_iso_utc !== "") {
      obj.obj_created_iso_utc = message.obj_created_iso_utc;
    }
    if (message.obj_updated_iso_utc !== "") {
      obj.obj_updated_iso_utc = message.obj_updated_iso_utc;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgFsdStructMeta>, I>>(base?: I): StcsOrgFsdStructMeta {
    return StcsOrgFsdStructMeta.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgFsdStructMeta>, I>>(object: I): StcsOrgFsdStructMeta {
    const message = createBaseStcsOrgFsdStructMeta();
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org_fsd_flat = object.ref_id_org_fsd_flat ?? "";
    message.fpna_industry = object.fpna_industry ?? 0;
    message.display_name = object.display_name ?? "";
    message.version_name = object.version_name ?? "";
    message.obj_created_iso_utc = object.obj_created_iso_utc ?? "";
    message.obj_updated_iso_utc = object.obj_updated_iso_utc ?? "";
    return message;
  },
};

function createBaseStcsOrgFsdStructFstmt(): StcsOrgFsdStructFstmt {
  return { fstmt_item_list: [] };
}

export const StcsOrgFsdStructFstmt: MessageFns<StcsOrgFsdStructFstmt> = {
  encode(message: StcsOrgFsdStructFstmt, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.fstmt_item_list) {
      StcsOrgFsdStructFstmtItem.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgFsdStructFstmt {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgFsdStructFstmt();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fstmt_item_list.push(StcsOrgFsdStructFstmtItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgFsdStructFstmt {
    return {
      fstmt_item_list: globalThis.Array.isArray(object?.fstmt_item_list)
        ? object.fstmt_item_list.map((e: any) => StcsOrgFsdStructFstmtItem.fromJSON(e))
        : [],
    };
  },

  toJSON(message: StcsOrgFsdStructFstmt): unknown {
    const obj: any = {};
    if (message.fstmt_item_list?.length) {
      obj.fstmt_item_list = message.fstmt_item_list.map((e) => StcsOrgFsdStructFstmtItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgFsdStructFstmt>, I>>(base?: I): StcsOrgFsdStructFstmt {
    return StcsOrgFsdStructFstmt.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgFsdStructFstmt>, I>>(object: I): StcsOrgFsdStructFstmt {
    const message = createBaseStcsOrgFsdStructFstmt();
    message.fstmt_item_list = object.fstmt_item_list?.map((e) => StcsOrgFsdStructFstmtItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStcsOrgFsdStructFstmtItem(): StcsOrgFsdStructFstmtItem {
  return {
    fpna_type: 0,
    id: "",
    level_id: "",
    total_list: [],
    sub_total_list: [],
    level_1_list: [],
    ctx_line_def: undefined,
    options: undefined,
  };
}

export const StcsOrgFsdStructFstmtItem: MessageFns<StcsOrgFsdStructFstmtItem> = {
  encode(message: StcsOrgFsdStructFstmtItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fpna_type !== 0) {
      writer.uint32(8).int32(message.fpna_type);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.level_id !== "") {
      writer.uint32(26).string(message.level_id);
    }
    for (const v of message.total_list) {
      StcsOrgFsdStructFstmtItem.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.sub_total_list) {
      StcsOrgFsdStructSubTotal.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.level_1_list) {
      StcsOrgFsdStructLevel1.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.ctx_line_def !== undefined) {
      StcsOrgFsdStructCtxLineDef.encode(message.ctx_line_def, writer.uint32(58).fork()).join();
    }
    if (message.options !== undefined) {
      StcsOrgFsdStructOptions.encode(message.options, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgFsdStructFstmtItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgFsdStructFstmtItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fpna_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.level_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.total_list.push(StcsOrgFsdStructFstmtItem.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.sub_total_list.push(StcsOrgFsdStructSubTotal.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.level_1_list.push(StcsOrgFsdStructLevel1.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ctx_line_def = StcsOrgFsdStructCtxLineDef.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.options = StcsOrgFsdStructOptions.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgFsdStructFstmtItem {
    return {
      fpna_type: isSet(object.fpna_type) ? stcsFpnaTypeEnumFromJSON(object.fpna_type) : 0,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      level_id: isSet(object.level_id) ? globalThis.String(object.level_id) : "",
      total_list: globalThis.Array.isArray(object?.total_list)
        ? object.total_list.map((e: any) => StcsOrgFsdStructFstmtItem.fromJSON(e))
        : [],
      sub_total_list: globalThis.Array.isArray(object?.sub_total_list)
        ? object.sub_total_list.map((e: any) => StcsOrgFsdStructSubTotal.fromJSON(e))
        : [],
      level_1_list: globalThis.Array.isArray(object?.level_1_list)
        ? object.level_1_list.map((e: any) => StcsOrgFsdStructLevel1.fromJSON(e))
        : [],
      ctx_line_def: isSet(object.ctx_line_def) ? StcsOrgFsdStructCtxLineDef.fromJSON(object.ctx_line_def) : undefined,
      options: isSet(object.options) ? StcsOrgFsdStructOptions.fromJSON(object.options) : undefined,
    };
  },

  toJSON(message: StcsOrgFsdStructFstmtItem): unknown {
    const obj: any = {};
    if (message.fpna_type !== 0) {
      obj.fpna_type = stcsFpnaTypeEnumToJSON(message.fpna_type);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.level_id !== "") {
      obj.level_id = message.level_id;
    }
    if (message.total_list?.length) {
      obj.total_list = message.total_list.map((e) => StcsOrgFsdStructFstmtItem.toJSON(e));
    }
    if (message.sub_total_list?.length) {
      obj.sub_total_list = message.sub_total_list.map((e) => StcsOrgFsdStructSubTotal.toJSON(e));
    }
    if (message.level_1_list?.length) {
      obj.level_1_list = message.level_1_list.map((e) => StcsOrgFsdStructLevel1.toJSON(e));
    }
    if (message.ctx_line_def !== undefined) {
      obj.ctx_line_def = StcsOrgFsdStructCtxLineDef.toJSON(message.ctx_line_def);
    }
    if (message.options !== undefined) {
      obj.options = StcsOrgFsdStructOptions.toJSON(message.options);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgFsdStructFstmtItem>, I>>(base?: I): StcsOrgFsdStructFstmtItem {
    return StcsOrgFsdStructFstmtItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgFsdStructFstmtItem>, I>>(object: I): StcsOrgFsdStructFstmtItem {
    const message = createBaseStcsOrgFsdStructFstmtItem();
    message.fpna_type = object.fpna_type ?? 0;
    message.id = object.id ?? "";
    message.level_id = object.level_id ?? "";
    message.total_list = object.total_list?.map((e) => StcsOrgFsdStructFstmtItem.fromPartial(e)) || [];
    message.sub_total_list = object.sub_total_list?.map((e) => StcsOrgFsdStructSubTotal.fromPartial(e)) || [];
    message.level_1_list = object.level_1_list?.map((e) => StcsOrgFsdStructLevel1.fromPartial(e)) || [];
    message.ctx_line_def = (object.ctx_line_def !== undefined && object.ctx_line_def !== null)
      ? StcsOrgFsdStructCtxLineDef.fromPartial(object.ctx_line_def)
      : undefined;
    message.options = (object.options !== undefined && object.options !== null)
      ? StcsOrgFsdStructOptions.fromPartial(object.options)
      : undefined;
    return message;
  },
};

function createBaseStcsOrgFsdStructOptions(): StcsOrgFsdStructOptions {
  return {
    filter_on_zero_sum_period: undefined,
    bs_cf_delta: undefined,
    is_cml: undefined,
    active_fstmt_side: undefined,
    invert_sum_value: 0,
    skip_path_level_1: undefined,
  };
}

export const StcsOrgFsdStructOptions: MessageFns<StcsOrgFsdStructOptions> = {
  encode(message: StcsOrgFsdStructOptions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.filter_on_zero_sum_period !== undefined) {
      writer.uint32(8).bool(message.filter_on_zero_sum_period);
    }
    if (message.bs_cf_delta !== undefined) {
      writer.uint32(16).bool(message.bs_cf_delta);
    }
    if (message.is_cml !== undefined) {
      writer.uint32(24).bool(message.is_cml);
    }
    if (message.active_fstmt_side !== undefined) {
      writer.uint32(32).bool(message.active_fstmt_side);
    }
    if (message.invert_sum_value !== 0) {
      writer.uint32(40).int32(message.invert_sum_value);
    }
    if (message.skip_path_level_1 !== undefined) {
      writer.uint32(48).bool(message.skip_path_level_1);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgFsdStructOptions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgFsdStructOptions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.filter_on_zero_sum_period = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.bs_cf_delta = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.is_cml = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.active_fstmt_side = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.invert_sum_value = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.skip_path_level_1 = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgFsdStructOptions {
    return {
      filter_on_zero_sum_period: isSet(object.filter_on_zero_sum_period)
        ? globalThis.Boolean(object.filter_on_zero_sum_period)
        : undefined,
      bs_cf_delta: isSet(object.bs_cf_delta) ? globalThis.Boolean(object.bs_cf_delta) : undefined,
      is_cml: isSet(object.is_cml) ? globalThis.Boolean(object.is_cml) : undefined,
      active_fstmt_side: isSet(object.active_fstmt_side) ? globalThis.Boolean(object.active_fstmt_side) : undefined,
      invert_sum_value: isSet(object.invert_sum_value) ? globalThis.Number(object.invert_sum_value) : 0,
      skip_path_level_1: isSet(object.skip_path_level_1) ? globalThis.Boolean(object.skip_path_level_1) : undefined,
    };
  },

  toJSON(message: StcsOrgFsdStructOptions): unknown {
    const obj: any = {};
    if (message.filter_on_zero_sum_period !== undefined) {
      obj.filter_on_zero_sum_period = message.filter_on_zero_sum_period;
    }
    if (message.bs_cf_delta !== undefined) {
      obj.bs_cf_delta = message.bs_cf_delta;
    }
    if (message.is_cml !== undefined) {
      obj.is_cml = message.is_cml;
    }
    if (message.active_fstmt_side !== undefined) {
      obj.active_fstmt_side = message.active_fstmt_side;
    }
    if (message.invert_sum_value !== 0) {
      obj.invert_sum_value = Math.round(message.invert_sum_value);
    }
    if (message.skip_path_level_1 !== undefined) {
      obj.skip_path_level_1 = message.skip_path_level_1;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgFsdStructOptions>, I>>(base?: I): StcsOrgFsdStructOptions {
    return StcsOrgFsdStructOptions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgFsdStructOptions>, I>>(object: I): StcsOrgFsdStructOptions {
    const message = createBaseStcsOrgFsdStructOptions();
    message.filter_on_zero_sum_period = object.filter_on_zero_sum_period ?? undefined;
    message.bs_cf_delta = object.bs_cf_delta ?? undefined;
    message.is_cml = object.is_cml ?? undefined;
    message.active_fstmt_side = object.active_fstmt_side ?? undefined;
    message.invert_sum_value = object.invert_sum_value ?? 0;
    message.skip_path_level_1 = object.skip_path_level_1 ?? undefined;
    return message;
  },
};

function createBaseStcsOrgFsdStructSubTotal(): StcsOrgFsdStructSubTotal {
  return {
    id: "",
    level_id: "",
    level_1_list: [],
    ctx_line_def: undefined,
    fpna_type: 0,
    options: undefined,
    ref_id_prefix: undefined,
    ref_id_mirror: undefined,
  };
}

export const StcsOrgFsdStructSubTotal: MessageFns<StcsOrgFsdStructSubTotal> = {
  encode(message: StcsOrgFsdStructSubTotal, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.level_id !== "") {
      writer.uint32(82).string(message.level_id);
    }
    for (const v of message.level_1_list) {
      StcsOrgFsdStructLevel1.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.ctx_line_def !== undefined) {
      StcsOrgFsdStructCtxLineDef.encode(message.ctx_line_def, writer.uint32(42).fork()).join();
    }
    if (message.fpna_type !== 0) {
      writer.uint32(48).int32(message.fpna_type);
    }
    if (message.options !== undefined) {
      StcsOrgFsdStructOptions.encode(message.options, writer.uint32(58).fork()).join();
    }
    if (message.ref_id_prefix !== undefined) {
      writer.uint32(66).string(message.ref_id_prefix);
    }
    if (message.ref_id_mirror !== undefined) {
      writer.uint32(74).string(message.ref_id_mirror);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgFsdStructSubTotal {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgFsdStructSubTotal();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.level_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.level_1_list.push(StcsOrgFsdStructLevel1.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ctx_line_def = StcsOrgFsdStructCtxLineDef.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.fpna_type = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.options = StcsOrgFsdStructOptions.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.ref_id_prefix = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.ref_id_mirror = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgFsdStructSubTotal {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      level_id: isSet(object.level_id) ? globalThis.String(object.level_id) : "",
      level_1_list: globalThis.Array.isArray(object?.level_1_list)
        ? object.level_1_list.map((e: any) => StcsOrgFsdStructLevel1.fromJSON(e))
        : [],
      ctx_line_def: isSet(object.ctx_line_def) ? StcsOrgFsdStructCtxLineDef.fromJSON(object.ctx_line_def) : undefined,
      fpna_type: isSet(object.fpna_type) ? stcsFpnaTypeEnumFromJSON(object.fpna_type) : 0,
      options: isSet(object.options) ? StcsOrgFsdStructOptions.fromJSON(object.options) : undefined,
      ref_id_prefix: isSet(object.ref_id_prefix) ? globalThis.String(object.ref_id_prefix) : undefined,
      ref_id_mirror: isSet(object.ref_id_mirror) ? globalThis.String(object.ref_id_mirror) : undefined,
    };
  },

  toJSON(message: StcsOrgFsdStructSubTotal): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.level_id !== "") {
      obj.level_id = message.level_id;
    }
    if (message.level_1_list?.length) {
      obj.level_1_list = message.level_1_list.map((e) => StcsOrgFsdStructLevel1.toJSON(e));
    }
    if (message.ctx_line_def !== undefined) {
      obj.ctx_line_def = StcsOrgFsdStructCtxLineDef.toJSON(message.ctx_line_def);
    }
    if (message.fpna_type !== 0) {
      obj.fpna_type = stcsFpnaTypeEnumToJSON(message.fpna_type);
    }
    if (message.options !== undefined) {
      obj.options = StcsOrgFsdStructOptions.toJSON(message.options);
    }
    if (message.ref_id_prefix !== undefined) {
      obj.ref_id_prefix = message.ref_id_prefix;
    }
    if (message.ref_id_mirror !== undefined) {
      obj.ref_id_mirror = message.ref_id_mirror;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgFsdStructSubTotal>, I>>(base?: I): StcsOrgFsdStructSubTotal {
    return StcsOrgFsdStructSubTotal.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgFsdStructSubTotal>, I>>(object: I): StcsOrgFsdStructSubTotal {
    const message = createBaseStcsOrgFsdStructSubTotal();
    message.id = object.id ?? "";
    message.level_id = object.level_id ?? "";
    message.level_1_list = object.level_1_list?.map((e) => StcsOrgFsdStructLevel1.fromPartial(e)) || [];
    message.ctx_line_def = (object.ctx_line_def !== undefined && object.ctx_line_def !== null)
      ? StcsOrgFsdStructCtxLineDef.fromPartial(object.ctx_line_def)
      : undefined;
    message.fpna_type = object.fpna_type ?? 0;
    message.options = (object.options !== undefined && object.options !== null)
      ? StcsOrgFsdStructOptions.fromPartial(object.options)
      : undefined;
    message.ref_id_prefix = object.ref_id_prefix ?? undefined;
    message.ref_id_mirror = object.ref_id_mirror ?? undefined;
    return message;
  },
};

function createBaseStcsOrgFsdStructCtxLineDef(): StcsOrgFsdStructCtxLineDef {
  return { ctx_line_type: 0, fstmt_ref_id: "", level_id: "" };
}

export const StcsOrgFsdStructCtxLineDef: MessageFns<StcsOrgFsdStructCtxLineDef> = {
  encode(message: StcsOrgFsdStructCtxLineDef, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ctx_line_type !== 0) {
      writer.uint32(16).int32(message.ctx_line_type);
    }
    if (message.fstmt_ref_id !== "") {
      writer.uint32(26).string(message.fstmt_ref_id);
    }
    if (message.level_id !== "") {
      writer.uint32(34).string(message.level_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgFsdStructCtxLineDef {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgFsdStructCtxLineDef();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.ctx_line_type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fstmt_ref_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.level_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgFsdStructCtxLineDef {
    return {
      ctx_line_type: isSet(object.ctx_line_type) ? stcsFpnaTypeEnumFromJSON(object.ctx_line_type) : 0,
      fstmt_ref_id: isSet(object.fstmt_ref_id) ? globalThis.String(object.fstmt_ref_id) : "",
      level_id: isSet(object.level_id) ? globalThis.String(object.level_id) : "",
    };
  },

  toJSON(message: StcsOrgFsdStructCtxLineDef): unknown {
    const obj: any = {};
    if (message.ctx_line_type !== 0) {
      obj.ctx_line_type = stcsFpnaTypeEnumToJSON(message.ctx_line_type);
    }
    if (message.fstmt_ref_id !== "") {
      obj.fstmt_ref_id = message.fstmt_ref_id;
    }
    if (message.level_id !== "") {
      obj.level_id = message.level_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgFsdStructCtxLineDef>, I>>(base?: I): StcsOrgFsdStructCtxLineDef {
    return StcsOrgFsdStructCtxLineDef.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgFsdStructCtxLineDef>, I>>(object: I): StcsOrgFsdStructCtxLineDef {
    const message = createBaseStcsOrgFsdStructCtxLineDef();
    message.ctx_line_type = object.ctx_line_type ?? 0;
    message.fstmt_ref_id = object.fstmt_ref_id ?? "";
    message.level_id = object.level_id ?? "";
    return message;
  },
};

function createBaseStcsOrgFsdStructLevel1(): StcsOrgFsdStructLevel1 {
  return {
    id: "",
    level_id: "",
    sum_ref: undefined,
    level_2_list: [],
    fpna_type: 0,
    options: undefined,
    ref_id_prefix: undefined,
    ref_id_mirror: undefined,
  };
}

export const StcsOrgFsdStructLevel1: MessageFns<StcsOrgFsdStructLevel1> = {
  encode(message: StcsOrgFsdStructLevel1, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.level_id !== "") {
      writer.uint32(82).string(message.level_id);
    }
    if (message.sum_ref !== undefined) {
      writer.uint32(34).string(message.sum_ref);
    }
    for (const v of message.level_2_list) {
      StcsOrgFsdStructLevel2.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.fpna_type !== 0) {
      writer.uint32(48).int32(message.fpna_type);
    }
    if (message.options !== undefined) {
      StcsOrgFsdStructOptions.encode(message.options, writer.uint32(58).fork()).join();
    }
    if (message.ref_id_prefix !== undefined) {
      writer.uint32(66).string(message.ref_id_prefix);
    }
    if (message.ref_id_mirror !== undefined) {
      writer.uint32(74).string(message.ref_id_mirror);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgFsdStructLevel1 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgFsdStructLevel1();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.level_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sum_ref = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.level_2_list.push(StcsOrgFsdStructLevel2.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.fpna_type = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.options = StcsOrgFsdStructOptions.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.ref_id_prefix = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.ref_id_mirror = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgFsdStructLevel1 {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      level_id: isSet(object.level_id) ? globalThis.String(object.level_id) : "",
      sum_ref: isSet(object.sum_ref) ? globalThis.String(object.sum_ref) : undefined,
      level_2_list: globalThis.Array.isArray(object?.level_2_list)
        ? object.level_2_list.map((e: any) => StcsOrgFsdStructLevel2.fromJSON(e))
        : [],
      fpna_type: isSet(object.fpna_type) ? stcsFpnaTypeEnumFromJSON(object.fpna_type) : 0,
      options: isSet(object.options) ? StcsOrgFsdStructOptions.fromJSON(object.options) : undefined,
      ref_id_prefix: isSet(object.ref_id_prefix) ? globalThis.String(object.ref_id_prefix) : undefined,
      ref_id_mirror: isSet(object.ref_id_mirror) ? globalThis.String(object.ref_id_mirror) : undefined,
    };
  },

  toJSON(message: StcsOrgFsdStructLevel1): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.level_id !== "") {
      obj.level_id = message.level_id;
    }
    if (message.sum_ref !== undefined) {
      obj.sum_ref = message.sum_ref;
    }
    if (message.level_2_list?.length) {
      obj.level_2_list = message.level_2_list.map((e) => StcsOrgFsdStructLevel2.toJSON(e));
    }
    if (message.fpna_type !== 0) {
      obj.fpna_type = stcsFpnaTypeEnumToJSON(message.fpna_type);
    }
    if (message.options !== undefined) {
      obj.options = StcsOrgFsdStructOptions.toJSON(message.options);
    }
    if (message.ref_id_prefix !== undefined) {
      obj.ref_id_prefix = message.ref_id_prefix;
    }
    if (message.ref_id_mirror !== undefined) {
      obj.ref_id_mirror = message.ref_id_mirror;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgFsdStructLevel1>, I>>(base?: I): StcsOrgFsdStructLevel1 {
    return StcsOrgFsdStructLevel1.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgFsdStructLevel1>, I>>(object: I): StcsOrgFsdStructLevel1 {
    const message = createBaseStcsOrgFsdStructLevel1();
    message.id = object.id ?? "";
    message.level_id = object.level_id ?? "";
    message.sum_ref = object.sum_ref ?? undefined;
    message.level_2_list = object.level_2_list?.map((e) => StcsOrgFsdStructLevel2.fromPartial(e)) || [];
    message.fpna_type = object.fpna_type ?? 0;
    message.options = (object.options !== undefined && object.options !== null)
      ? StcsOrgFsdStructOptions.fromPartial(object.options)
      : undefined;
    message.ref_id_prefix = object.ref_id_prefix ?? undefined;
    message.ref_id_mirror = object.ref_id_mirror ?? undefined;
    return message;
  },
};

function createBaseStcsOrgFsdStructLevel2(): StcsOrgFsdStructLevel2 {
  return {
    id: "",
    level_id: "",
    sum_ref: undefined,
    options: undefined,
    fpna_type: 0,
    ref_id_prefix: undefined,
    ref_id_mirror: undefined,
  };
}

export const StcsOrgFsdStructLevel2: MessageFns<StcsOrgFsdStructLevel2> = {
  encode(message: StcsOrgFsdStructLevel2, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.level_id !== "") {
      writer.uint32(82).string(message.level_id);
    }
    if (message.sum_ref !== undefined) {
      writer.uint32(34).string(message.sum_ref);
    }
    if (message.options !== undefined) {
      StcsOrgFsdStructOptions.encode(message.options, writer.uint32(42).fork()).join();
    }
    if (message.fpna_type !== 0) {
      writer.uint32(48).int32(message.fpna_type);
    }
    if (message.ref_id_prefix !== undefined) {
      writer.uint32(58).string(message.ref_id_prefix);
    }
    if (message.ref_id_mirror !== undefined) {
      writer.uint32(74).string(message.ref_id_mirror);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgFsdStructLevel2 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgFsdStructLevel2();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.level_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sum_ref = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.options = StcsOrgFsdStructOptions.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.fpna_type = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ref_id_prefix = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.ref_id_mirror = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgFsdStructLevel2 {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      level_id: isSet(object.level_id) ? globalThis.String(object.level_id) : "",
      sum_ref: isSet(object.sum_ref) ? globalThis.String(object.sum_ref) : undefined,
      options: isSet(object.options) ? StcsOrgFsdStructOptions.fromJSON(object.options) : undefined,
      fpna_type: isSet(object.fpna_type) ? stcsFpnaTypeEnumFromJSON(object.fpna_type) : 0,
      ref_id_prefix: isSet(object.ref_id_prefix) ? globalThis.String(object.ref_id_prefix) : undefined,
      ref_id_mirror: isSet(object.ref_id_mirror) ? globalThis.String(object.ref_id_mirror) : undefined,
    };
  },

  toJSON(message: StcsOrgFsdStructLevel2): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.level_id !== "") {
      obj.level_id = message.level_id;
    }
    if (message.sum_ref !== undefined) {
      obj.sum_ref = message.sum_ref;
    }
    if (message.options !== undefined) {
      obj.options = StcsOrgFsdStructOptions.toJSON(message.options);
    }
    if (message.fpna_type !== 0) {
      obj.fpna_type = stcsFpnaTypeEnumToJSON(message.fpna_type);
    }
    if (message.ref_id_prefix !== undefined) {
      obj.ref_id_prefix = message.ref_id_prefix;
    }
    if (message.ref_id_mirror !== undefined) {
      obj.ref_id_mirror = message.ref_id_mirror;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgFsdStructLevel2>, I>>(base?: I): StcsOrgFsdStructLevel2 {
    return StcsOrgFsdStructLevel2.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgFsdStructLevel2>, I>>(object: I): StcsOrgFsdStructLevel2 {
    const message = createBaseStcsOrgFsdStructLevel2();
    message.id = object.id ?? "";
    message.level_id = object.level_id ?? "";
    message.sum_ref = object.sum_ref ?? undefined;
    message.options = (object.options !== undefined && object.options !== null)
      ? StcsOrgFsdStructOptions.fromPartial(object.options)
      : undefined;
    message.fpna_type = object.fpna_type ?? 0;
    message.ref_id_prefix = object.ref_id_prefix ?? undefined;
    message.ref_id_mirror = object.ref_id_mirror ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
